export default "__VITE_ASSET__0y7SDAu___"